/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-29 18:10:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-12 14:50:50
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/SectionTitle/index.tsx
 */
import { SectionTitle, StyledSectionTitle } from 'src/components/Layouts';
export default SectionTitle;
export { StyledSectionTitle as StyledTitle };
